import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  Input,
  OnDestroy,
  OnInit,
} from '@angular/core';
import { Subject } from 'rxjs';
import { distinctUntilChanged, map, take, takeUntil } from 'rxjs/operators';

import { RemoteDiagnosticsStore, VddDetailsListStore } from '@store';
import { RemoteDiagnosticsVddGenericStructure, SvgVddMapping } from '@vi-iot/client';
import { ActivatedRoute } from '@angular/router';
import { CustomTranslationsService } from '../../../../../operational-data-common/translations';
import { SemanticValues } from '../../extended-parameters/diagnostics-constants';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-hydraulic-schematic-vdd-table-item',
  templateUrl: './hydraulic-schematic-vdd-table-item.component.html',
  styleUrls: ['./hydraulic-schematic-vdd-table-item.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class HydraulicSchematicVddTableItemComponent implements OnInit, OnDestroy {
  @Input() vdd: SvgVddMapping;
  gatewaySerial: string;
  matchedValues: RemoteDiagnosticsVddGenericStructure[];
  isVddLoading: boolean;
  readonly vddItems = ['id', 'feature', 'value'];

  constructor(
    private vddDetailsListStore: VddDetailsListStore,
    private cdr: ChangeDetectorRef,
    private activatedRoute: ActivatedRoute,
    private remoteDiagnosticsStore: RemoteDiagnosticsStore,
    private customTranslationsService: CustomTranslationsService,
    private translateService: TranslateService
  ) {}

  private ngUnsubscribe$: Subject<void> = new Subject<void>();

  ngOnInit(): void {
    this.activatedRoute.queryParams.subscribe((queryParams) => {
      this.gatewaySerial = queryParams?.gatewaySerial;
    });

    this.remoteDiagnosticsStore
      .getMainLogicalLinkFromTopology(this.gatewaySerial)
      .pipe(take(1))
      .subscribe((logicalLink) => {
        this.vddDetailsListStore
          .selectMatchedValues(this.vdd.feature, logicalLink)
          .pipe(
            distinctUntilChanged(),
            map((values) =>
              values.filter((matchedValue) =>
                matchedValue?.semantic?.includes(SemanticValues.VALUE)
              )
            ),
            takeUntil(this.ngUnsubscribe$)
          )
          .subscribe((values) => {
            this.matchedValues = values;
            this.cdr.detectChanges();
          });

        this.vddDetailsListStore
          .isVddLoading(this.vdd.feature, logicalLink)
          .pipe(takeUntil(this.ngUnsubscribe$))
          .subscribe((isVddLoading) => {
            this.isVddLoading = isVddLoading;
            this.cdr.detectChanges();
          });
      });
  }

  ngOnDestroy(): void {
    this.ngUnsubscribe$.next();
    this.ngUnsubscribe$.complete();
  }

  getItemTitleTranslationKey(translation: string): string {
    return this.translateService.instant(
      this.customTranslationsService.HYDRAULIC_SCHEMATIC_TABLE_HEADERS[translation]
    );
  }
}
